var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGridActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "grid-active") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#00a0e9;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1269 -193)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 9,
    height: 9,
    rx: 1,
    transform: "translate(1269 193)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 9,
    height: 9,
    rx: 1,
    transform: "translate(1269 204)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 9,
    height: 9,
    rx: 1,
    transform: "translate(1280 193)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 9,
    height: 9,
    rx: 1,
    transform: "translate(1280 204)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridActive);
export default __webpack_public_path__ + "static/media/grid_active.01ff58e507fd049810bde76e4d97f4b5.svg";
export { ForwardRef as ReactComponent };